import styled from '@emotion/styled'

export const StyleContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: 0 auto;

  ${(props: any) => props?.customStyle}
`
